/**
      *********************************************************
      Description: Formheader component.
      Required props:  N/A
      limitations    : Doesn't handle state. Needs to handle state in parent component for save, edit button
      *********************************************************
**/

import React, { Fragment } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { withRouter } from 'react-router-dom'
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import AddIcon from '@material-ui/icons/Add';

import CloseIcon from '@material-ui/icons/Close';
import BreadCrumb from '../breadcrumbs';
import Icon from '@material-ui/core/Icon';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { getSiteAccess } from '../header';
import SendIcon from '@material-ui/icons/Send';
import ExportExcel from '@material-ui/icons/SaveAlt';
import FilterListIcon from '@material-ui/icons/ClearAll';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import KendoHeader from '../../controls/components/kendoheader';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import { getEnvVariable } from '../../../modules/environmentalList';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import DoneOutlineIcon from '@material-ui/icons/DoneOutline';
import ContactMailIcon from '@material-ui/icons/ContactMail';
import NotesIcon from '@material-ui/icons/Notes';
import Print from '@material-ui/icons/Print';
import CachedIcon from '@material-ui/icons/Cached';
import GetAppIcon from '@material-ui/icons/GetApp';
import History from '../../controls/components/history';

const items = [{
    name: 'Export Current Page',
    action: 'filtercurrent'
},
{
    name: 'Export All Pages',
    action: 'filterall'
}
]

const styles = {
    root: {
        flexGrow: 1,
    },
    grow: {
        flexGrow: 1,
    },
    menuButton: {

    },
};
const checkwidth = 960

class CFormHeader extends React.Component {

    state = {
        openSlide: false,
        width: window.innerWidth,
        displayicon: window.innerWidth > checkwidth ? true : false,
        anchorEl: null
    }

    updateDimensions = () => {
        if (window.innerWidth < checkwidth) {
            this.setState({ width: window.innerWidth, displayicon: false });
        }
        else {
            this.setState({ displayicon: true });
        }
    };


    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }


    /**
       *********************************************************
       Description: Renders the form header with action icons. When the user accessPermissions Add and Edit button are activated.
       Required props:  N/A
       limitations    : Doesn't handle state. Needs to handle state in parent component for save, edit button
       *********************************************************
**/
    handleAdd = () => {
        const { sidebar } = this.props
        if (sidebar) {
            this.setState({ openSlide: true }, () => { this.props.handleFormGrid() })
        }
        else {
            this.props.handleAdd();
        }
    }


    handleSlide = () => {
        this.setState({ openSlide: false }, () => this.props.handleSlide())
    }


    handleExport = (event) => {
        this.setState({ anchorEl: event.currentTarget })
    };

    handleClose = (evt, action) => {
        this.setState({ anchorEl: null }, () => {
            if (action === 'filterall' || action === 'filtercurrent')
                this.props.export(action)
        })
    };


    CreateNewRecord = (options) => (event) => {
        const { crud } = options
        const { create } = crud
        const { link } = create;
        if (link && Array.isArray(link)) {
            let pushLink = '';
            link.forEach(each => {
                const { link, matchProps } = each
                pushLink += link + (matchProps ? (this.props.match.params[matchProps.value] && ('/' + this.props.match.params[matchProps.value])) : '');
                link && this.props.history.replace(`${pushLink}`)
            })
        }
        else if (link.type === 'sublink') {
            this.props.history.push(`${this.props.location.pathname}${link.link}`)
        }
        else {
            link && this.props.history.push(`${link.link}`)
        }

    }

    getColor = () => {
        let module = getEnvVariable('ModuleKey')
        switch (module) {
            case 'AEPS':
                return 'rgba(0, 53, 95, 255)'
            case 'AMES':
                return '#1976d2'
            default:
                return '';
        }
    }

    /**
     * Custombutton
     * Use: Allows  the user to add custom button along with edit , handleCustom triggers the function in the moduel by props
     */
    render() {

        const { actions, title, customtitle, customicon, doneoutline, contactbutton, notesbutton, printbutton, custombutton, components, compmap,
            add, editbutton, savebutton, savetemplatebutton, sendtemplatebutton, addbutton, backbutton, historyurl, historyalign, alignresend, results,
            closebutton, handleClose, accessPermissions, accessLevelPermissions, breadcrumbs, materialicon, isedited, customprops, customId, designprops, sendbutton,
            gridprops, reportbutton, excelbutton, filterbutton, onFullScreen, onExitFullScreen, fullscreen, exitfullscreen, dataItem, nonstickyposition, navigateup,
            navigatedown, customheader, duplicatebutton, iseditduplicate, rowrenderedslide, hasclearfix, resetbutton, downloadbutton, className, refreshbutton } = this.props;
        const { isAdmin } = accessPermissions ? accessPermissions : {}
        const addaccessPermissions = getEnvVariable('AccessPortal') === "I" ? (isAdmin ? (isAdmin === 'Y') : null) : (true)
        const editaccessPermissions = isAdmin ? (isAdmin === 'Y') : null;
        const { openSlide } = this.state
        // const showaddedit = getSiteAccess(moduleInput ? moduleInput : null)
        return (
            <>
                {designprops && <div className='p-2 float-end'>
                    {alignresend && <span></span>}
                    {editbutton && !isedited && <IconButton size="small" color="primary" aria-label="Edit" className="float-end zoom mx-1" title={`Edit ${title}`} onClick={(e) => this.props.handleEdit(e, false)}>
                        <EditIcon />
                    </IconButton>}
                    {hasclearfix && <div className='clearfix' />}
                    <div className="float-end">&nbsp;&nbsp;</div>
                    {duplicatebutton && !isedited && getEnvVariable('AccessPortal' !== 'E') && <IconButton size="small" color="primary" aria-label="Clone" className="float-end zoom mx-1" title={`Clone ${title}`} onClick={(e) => this.props.handleEdit(e, true)}>
                        <FileCopyIcon />
                    </IconButton>}
                    {alignresend && <span></span>}
                    {alignresend && <span></span>}
                    {historyurl && !historyalign && <span className="float-end"></span>}

                    {hasclearfix && <div className='clearfix' />}
                    {savebutton && iseditduplicate && <IconButton size="small" color="primary" aria-label="Save" className="float-end zoom mx-1" title={`Save ${title}`} onClick={(e) => this.props.handleSave(e, true)}>
                        <SaveIcon />
                    </IconButton>}
                    {refreshbutton && <IconButton size="small" color="primary" aria-label="Save" className="float-end zoom mx-1" title={`Refresh ${title}`} onClick={(e) => this.props.handleRefresh(e, true)}>
                        <CachedIcon />
                    </IconButton>}
                    {savebutton && !iseditduplicate && <IconButton size="small" color="primary" aria-label="Save" className="float-end Zoom mx-2" title={`Save ${title}`} onClick={(e) => this.props.handleSave(e, false)}>
                        <SaveIcon />
                    </IconButton>}
                    {savetemplatebutton && <IconButton size="small" color="primary" aria-label="Save" className="float-end zoom mx-1" title="Send" onClick={(e) => this.props.SaveTemplateInfo(null, null, 'initialsave')}>
                        <SendIcon />
                    </IconButton>}
                    {hasclearfix && <div className='clearfix' />}
                    {sendbutton && <IconButton size="small" color="primary" aria-label="Save" className="float-end zoom mx-1" title="Send" onClick={this.props.handleSave}>
                        <SendIcon />
                    </IconButton>}
                    {alignresend && isedited && <span></span>}
                    {historyurl && <History url={historyurl} fieldValues={results} />}
                    {hasclearfix && <div className='clearfix' />}
                    {contactbutton &&
                        <IconButton size="small" color="primary" aria-label="Save" className="float-end zoom mx-1" title="Non Responders" onClick={(e) => this.props.handleContact(e, true)}>
                            <ContactMailIcon />
                        </IconButton>}
                    {notesbutton &&
                        <IconButton size="small" color="primary" aria-label="Save" className="float-end zoom mx-1" title="Notes" onClick={this.props.handleNotes}>
                            <NotesIcon />
                        </IconButton>}
                    {hasclearfix && <div className='clearfix' />}
                    {doneoutline &&
                        <IconButton size="small" color="primary" aria-label="Save" className="float-end zoom mx-1" title="Send" onClick={(e) => this.props.handleDoneOutline(e, false)}>
                            <DoneOutlineIcon />
                        </IconButton>}
                    {hasclearfix && <div className='clearfix' />}
                    {printbutton &&
                        <IconButton size="small" color="primary" aria-label="Print" className="float-end zoom mx-1" title="Print" onClick={this.props.handlePrint}>
                            <Print />
                        </IconButton>}
                </div>}
                {hasclearfix && <div className='clearfix' />}
                {this.props.headerProps && this.props.headerProps.kendogridprops && <KendoHeader {...this.props.headerProps} {...{
                    addOnsByName:
                    {
                        add: {
                            onClick: (this.props.addtype && this.props.addtype === 'CreateNewRecord') ?
                                this.CreateNewRecord(this.props.addactions[0].options) : this.handleAdd
                        }, excel: { onClick: this.props.export }, reports:
                            { onClick: this.props.saveReport }, clear: { onClick: this.props.clearFilters }, back: { onClick: this.props.handleBack },
                    }
                }} />}
                {gridprops && <div>
                    {(addaccessPermissions) && actions && actions.map(each => {
                        const { type, options, key, sidepopup } = each
                        switch ((add === false) ? '' : type) {
                            case 'createnewrecordicon':
                                return <div>
                                    <div className="float-end">&nbsp;&nbsp;</div>
                                    <IconButton className="float-end  zoom mx-1" size="small" color="primary" title={"Add " + title} aria-label="add" key={key} onClick={sidepopup ? this.handleAdd : this.CreateNewRecord(options)}>
                                        <AddIcon />
                                    </IconButton>
                                </div>
                            default: return <></>
                        }
                    })}
                    {/* <IconButton size="small" color="primary" aria-label="Export to  Excel" title="Export to Excel" className="col float-end" onClick={this.props.export}>
                        <ExportExcel />
                    </IconButton> */}
                    <IconButton size="small" color="primary" aria-label="Export to  Excel" title="Export to Excel" className="col float-end" onClick={this.handleExport}>
                        <ExportExcel />
                    </IconButton>
                    <Menu
                        id="simple-menu"
                        anchorEl={this.state.anchorEl}
                        keepMounted
                        open={Boolean(this.state.anchorEl)}
                        onClose={this.handleClose}
                    >
                        {items.map(each => { return <MenuItem onClick={(evt) => this.handleClose(evt, each.action)}>{each.name}</MenuItem> })}
                    </Menu>
                    <IconButton size="small" color="primary" aria-label="Save Report" className="float-end" title="Save Report" onClick={this.props.saveReport}>
                        <SaveIcon />
                    </IconButton>

                    <IconButton size="small" color="primary" aria-label="Save Report" className="float-end" title="Clear Filters" onClick={this.props.clearFilters}>
                        <FilterListIcon />
                    </IconButton>
                </div>
                }
                {!designprops && !customheader && <AppBar className=" application-border" position={nonstickyposition ? "static" : "sticky"} elevation={0}>
                    <Toolbar variant="dense">
                        {breadcrumbs && <div className=" pt-2 px-1">
                            <BreadCrumb breadcrumbs={breadcrumbs} dataItem={dataItem} />
                        </div>}{!breadcrumbs && <div className="row " >{materialicon && <Fragment><Icon style={{ lineHeight: '29px', color: 'black' }}>{materialicon}</Icon>&nbsp;</Fragment>}{title}</div>}

                        <div className='flex-grow-1' />
                        <>
                            {custombutton && <i className="zoom mx-1" onClick={this.props.handleCustom} ><IconButton title={customtitle || title} className="zoom mx-1" color='primary' size='small'>
                                <Icon >{customicon}</Icon>
                            </IconButton></i>}
                            {resetbutton && <i className="zoom mx-1" onClick={(e) => this.props.handleReset(e)} ><IconButton title="Reset" color='primary' size='small'>
                                <CachedIcon />
                            </IconButton></i>}
                            {backbutton && <i className="zoom mx-1" onClick={(e) => this.props.handleBack(e)} ><IconButton title="Back" color='primary' size='small' >
                                <ChevronLeftIcon />
                            </IconButton></i>}
                            {filterbutton && <i className="zoom mx-1" onClick={this.props.clearFilters}><IconButton title="Clear Filters" color='primary' size='small'>
                                <FilterListIcon />
                            </IconButton></i>}
                            {reportbutton && <i className="zoom mx-1" onClick={this.props.saveReport}><IconButton title="Save Report" color='primary' size='small'>
                                <SaveIcon />
                            </IconButton></i>}
                            {refreshbutton && <i className="zoom mx-1" onClick={this.props.handleRefresh}><IconButton title="Refresh Cache" color='primary' size='small'>
                                <CachedIcon />
                            </IconButton></i>}
                            {excelbutton &&
                                <Fragment>
                                    <i className="zoom mx-1" onClick={this.handleExport}><IconButton title="Export to Excel" color='primary' size='small'>
                                        <ExportExcel />
                                    </IconButton></i>
                                    <Menu
                                        id="simple-menu"
                                        anchorEl={this.state.anchorEl}
                                        keepMounted
                                        open={Boolean(this.state.anchorEl)}
                                        onClose={this.handleClose}
                                    >
                                        {items.map(each => { return <MenuItem onClick={(evt) => this.handleClose(evt, each.action)}>{each.name}</MenuItem> })}
                                    </Menu>
                                </Fragment>
                            }
                            {downloadbutton && <i className="zoom mx-1" onClick={this.props.handleDownload}><IconButton title="Download" color='primary' size='small'>
                                <GetAppIcon />
                            </IconButton></i>}
                            {addbutton && <i className="zoom mx-1" onClick={this.handleAdd}><IconButton title={`Add ${title}`} color='primary' size='small'>
                                <AddIcon />
                            </IconButton></i>}
                            {editbutton && !isedited && <i className="zoom mx-1" onClick={this.props.handleEdit} >  <IconButton title={`Edit ${title}`} color='primary' size='small'>
                                <EditIcon />
                            </IconButton></i>}

                            {duplicatebutton && !isedited && getEnvVariable('AccessPortal' !== 'E') && <i className="zoom mx-1" onClick={(e) => this.props.handleEdit(e, true)}><IconButton title={`Clone ${title}`} color='primary' size='small'>
                                <FileCopyIcon />
                            </IconButton></i>}


                            {savebutton && iseditduplicate && <i className="zoom mx-1" onClick={(e) => this.props.handleSave(e, true)} ><IconButton title={`Save ${title}`} color='primary' size='small' style={{ backgroundColor: '#ede7f6', color: 'primary' }}>
                                <SaveIcon />
                            </IconButton></i>}
                            {savebutton && !iseditduplicate && <i className="zoom mx-1" onClick={(e) => this.props.handleSave(e, false)} ><IconButton title={`Save ${title}`} color='primary' size='small' style={{ backgroundColor: '#ede7f6', color: 'primary' }}>
                                <SaveIcon />
                            </IconButton></i>}
                            {historyurl && <History className="zoom mx-1" url={historyurl} fieldValues={results} />}
                            {closebutton && <i className="zoom mx-1" onClick={this.props.handleClose} ><IconButton title="Close" color='primary' size='small'>
                                <CloseIcon />
                            </IconButton></i>}
                            {sendbutton && <i className="zoom mx-1" onClick={this.props.handleSave} ><IconButton title="Send" color='primary' size='small'>
                                <SendIcon />
                            </IconButton></i>}
                            {savetemplatebutton && <i className="zoom mx-1" onClick={(e) => this.props.SaveTemplateInfo(null, null, 'initialsave')} ><IconButton title="Send" size='small' style={{ backgroundColor: '#ede7f6', color: 'primary' }}>
                                <SendIcon />
                            </IconButton></i>}
                            {sendtemplatebutton && <i className="zoom mx-1" onClick={(e) => this.props.SaveTemplateInfo(null, null, 'initialsave')} ><IconButton title="Email Me" color='primary' size='small' style={{ backgroundColor: '#ede7f6', color: 'primary' }}>
                                <SendIcon />
                            </IconButton></i>}
                            {rowrenderedslide && navigateup && <i className="zoom mx-1" onClick={this.props.onPrevItemClick ? this.props.onPrevItemClick : this.props.onPrevItem} ><IconButton title="Previous Item" color='primary' size='small'>
                                <ArrowUpwardIcon />
                            </IconButton></i>}
                            {rowrenderedslide && navigatedown && <i className="zoom mx-1" onClick={this.props.onNextItemClick ? this.props.onNextItemClick : this.props.onNextItem} ><IconButton title="Next Item" color='primary' size='small'>
                                <ArrowDownwardIcon />
                            </IconButton></i>}
                            {this.state.displayicon && !fullscreen && exitfullscreen && <i className="zoom mx-1" onClick={this.props.onFullScreen} ><IconButton title="Full Screen" color='primary' size='small'>
                                <FullscreenIcon />
                            </IconButton></i>}
                            {this.state.displayicon && fullscreen && <i className="zoom mx-1" onClick={this.props.onExitFullScreen} ><IconButton title="Exit Full Screen" color='primary' size='small'>
                                <FullscreenExitIcon />
                            </IconButton></i>}
                        </>
                    </Toolbar>
                </AppBar>}
                {/* subgrid - represents the form header true or false*/
                    openSlide && components && components.map(each => {
                        const EachComp = compmap[each.type]
                        return <EachComp {...each} key={each.key} handleSlide={this.handleSlide} addSubGrid={true} compmap={compmap}
                            accessPermissions={accessPermissions} accessLevelPermissions={accessLevelPermissions} customprops={customprops}
                            customId={customId} dataItem={this.props.dataItem} handleCustomBack={this.props.handleCustomBack} />
                    })
                }
            </ >

        );
    }
}
export default withRouter(CFormHeader);
